export default "__VITE_ASSET__BAGqds20__"